import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next';
import { Row, Col } from 'reactstrap';
import { PageTitle, CoursesCalendar } from '../../components';
import { matchSorter } from 'match-sorter';
import AdminDashboard from './AdminDashboard/AdminDashboard';
import PublicDashboard from './PublicDashboard/PublicDashboard';

import './Dashboard.css';
import { loadCourses, loadSubjects } from '../../redux';
import Icon from '@mdi/react';
import {
    mdiSchoolOutline,
    mdiCastEducation,
    mdiEyeArrowRightOutline,
    mdiAccountArrowRightOutline,
    mdiAccountSearchOutline,
    mdiClose,
} from '@mdi/js';

const Dashboard = props => {
    const { t }    = useTranslation();
    const dispatch = useDispatch();

    const { user }      = useSelector(state => state.auth);
    const {
        courses,
        hasLoadingError,
        loadingErrorMessage
    } = useSelector(state => state.courses);

    useEffect(() => {
        dispatch(loadCourses());
    }, [])

    const calendar = React.useMemo(() => (
        <CoursesCalendar
            courses={courses}
            groupBy={'groupId'}
            defaultView="day"
            onlyAgenda={true}
        />
    ), [courses]);

    return (
        <div className="Dashboard">
            <Row>
                <Col lg="8">
                    <PageTitle icon={mdiSchoolOutline} title={t('dashboard.welcome')} />
                    { !user && (
                        <PublicDashboard />
                    )}
                    { user?.isAdmin() && (
                        <AdminDashboard />
                    )}
                </Col>
                <Col lg="4">
                    <PageTitle icon={mdiCastEducation} title={t('dashboard.next_courses')} />
                    { courses && calendar }
                </Col>
            </Row>
        </div>
    );
}

export default Dashboard;
